var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShampoo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1935.118,
    height: 1935.118,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.103 440.957c-2.599-11.574-15.097-65.022-27.774-118.774-13.096-55.531-21.786-102.758-20.126-109.374 3.118-12.424 19.397-28.663 37.955-37.863 8.261-4.095 11.758-10.595 12.867-23.92l1.524-18.296h77.36l1.524 18.296c1.105 13.265 4.612 19.828 12.754 23.863 23.115 11.458 35.419 27.513 35.126 45.834-.154 9.654-8.488 67.258-18.518 128.009l-18.238 110.455-44.865 1.407L218.828 462zm10.423-329.125c-1.256-2.045 1.17-5.042 5.392-6.662 10.331-3.965 10.585-39 .311-42.943-4.05-1.555-7.364-5.201-7.364-8.104 0-3.412 12.583-4.768 35.592-3.836l35.59 1.442 1.452 30.27 1.45 30.27-35.07 1.639c-19.289.902-36.098-.037-37.353-2.078z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShampoo);
export default __webpack_public_path__ + "static/media/shampoo.2955f431.svg";
export { ForwardRef as ReactComponent };